<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="600">
    <v-card v-if="activePairingData">
      <v-card-title class="headline">Update Paired Influencer</v-card-title>
      <v-card-text>
        <a
          class="title"
          :href="'https://www.instagram.com/' + activePairingData.instagramHandle"
          target="_blank"
        >@{{activePairingData.instagramHandle}}</a>
        <v-select
          v-model="activePairingData.pairingStatus"
          :items="pairingStatusOptions"
          item-value="status"
          item-text="display"
          :disabled="viewOnly"
          label="Pairing Status"
        ></v-select>
        <v-row>
          <v-col cols="12" md="6" sm="12" lg="6">
            <v-text-field
              label="Min Amount"
              v-model.number="activePairingData.min_payout"
              :disabled="viewOnly"
              type="number"
              prefix="S$"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6" sm="12" lg="6">
            <v-text-field
              label="Max Amount"
              :disabled="viewOnly"
              v-model.number="activePairingData.max_payout"
              type="number"
              prefix="S$"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              outlined
              name="remarks"
              label="Remarks"
              :disabled="viewOnly"
              hide-details
              v-model="activePairingData.remarks"
              value
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="green darken-1" text @click="updatePairingStatus()" :disabled="viewOnly">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import pairingAPIs from '../../Pairing/pairingAPIs';
// import config from '../config';
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      activePairingData: null
    };
  },
  props: {
    value: Boolean,
    viewOnly: Boolean,
    data: Object
  },
  watch: {
    data(value) {
      if (value) {
        this.activePairingData = Object.assign({}, value);
      }
    }
  },
  computed: {
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    pairingStatusOptions: function() {
      let data = [];
      Object.entries(this.pairingStatus).forEach(item => {
        data.push({
          status: item[1].value,
          display: item[1].text
        });
      });
      return data;
    }
  },
  methods: {
    updatePairingStatus() {
      if (this.activePairingData !== null) {
        let data = {
          pairingID: this.activePairingData.pairingID,
          pairingStatus: this.activePairingData.pairingStatus,
          remarks: this.activePairingData.remarks,
          min_payout: this.activePairingData.min_payout,
          max_payout: this.activePairingData.max_payout
        };
        pairingAPIs
          .updatePairingStatus(data)
          .then(() => {
            this.$swal({
              position: 'top-center',
              title: 'Status Updated',
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            this.$emit('pairChanged');
          })
          .catch(error => {
            this.$swal({
              position: 'top-center',
              title: 'Error while updating pairing',
              type: 'error',
              timer: 1500
            });
            console.log(error);
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// SettingsForPairing.vue?7ebbd99a